import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { FormattedMessage, defineMessages } from 'react-intl'
import { AmplitudeContext } from '@homebot/shared-util-quartermaster'

// Constants
import { OVERLAY_HELPERS } from '../../../../../constants/navigation'
import { REFI_WIN } from '../../../../../constants/wins'

// Contexts
import { useTheme } from '@homebot/shared-ui-swashbuckle'

// Selectors
import {
  selectRefiShorttermSavingsKey,
  selectRefiShorttermSavings,
} from '../../../../../store/selectors/refinance'
import { selectRefi30FixedVideoThumbnail } from '../../../../../store/selectors/videos'

// Components
import { Text, Format } from '../../../..'
import ImportantNowCard from '../../ImportantNowCard'

// Assets
import DefaultThemeSvg from './DefaultThemeSvg'
import LightThemeSvg from './LightThemeSvg'

const newHomeMessages = defineMessages({
  nav: {
    id: 'ImportantNow.newHome.nav',
    defaultMessage: '\u25b6 Watch video',
  },
})

const Refi = () => {
  const diffInPayments = useSelector(selectRefiShorttermSavings)
  const refiSavingsKey = useSelector(selectRefiShorttermSavingsKey)
  const videoThumbnailUrl = useSelector(selectRefi30FixedVideoThumbnail)

  const savingsInPayments = Math.abs(diffInPayments)

  const { theme } = useTheme()
  const { ampli } = useContext(AmplitudeContext)

  const Svg = theme.isLightThemeType ? LightThemeSvg : DefaultThemeSvg

  return (
    <ImportantNowCard
      name='Refi'
      event={() => ampli?.winClicked({ win_type: REFI_WIN })}
      svgImage={Svg}
      navTo={OVERLAY_HELPERS.refinance.buildPath(refiSavingsKey)}
      imageUrl={videoThumbnailUrl}
      navMessage={videoThumbnailUrl && newHomeMessages.nav}
    >
      <FormattedMessage
        id='ImportantNow.spotlight.refi'
        defaultMessage='A 30-year refi could save you around {bold}'
        values={{
          bold: (
            <Text element='span' weight='semibold' variant='success'>
              <Format.Currency value={savingsInPayments} abbreviate />
              <FormattedMessage
                id='ImportantNow.spotlight.refi.bold'
                defaultMessage='/mo'
              />
            </Text>
          ),
        }}
      />
    </ImportantNowCard>
  )
}

Refi.propTypes = {}

export default Refi
